import {DefaultTheme} from 'styled-components';

// eslint-disable-next-line no-restricted-imports
import {path} from 'ramda';

export const getThemeToken = (theme: DefaultTheme, key: string): string =>
  path<string>(key.split('.'), theme) ?? '';
